// extracted by mini-css-extract-plugin
module.exports = {"triggerButton":"styles_triggerButton__2e0Qt","closeButton":"styles_closeButton__3KpLk"};